import type React from 'react';
import AfterEffectsIcon from '@/components/Icons/MGFormats/AfterEffects';
import DaVinciResolveIcon from '@/components/Icons/MGFormats/DaVinciResolve';
import DragAndDropIcon from '@/components/Icons/MGFormats/DragAndDrop';
import PremiereProIcon from '@/components/Icons/MGFormats/PremierePro';
import { Compatibility, type CompatibilityType } from '@/components/TypesenseFilters/types';
import FinalCutProIcon from '../Icons/MGFormats/FinalCutPro';
interface MGCompatibilityIconProps {
  className?: string;
  compatibility: CompatibilityType;
  icon?: React.ReactNode;
}
type IconComponent = typeof AfterEffectsIcon | typeof DragAndDropIcon | typeof PremiereProIcon | typeof DaVinciResolveIcon;
const compatibilityIcons: Record<CompatibilityType, IconComponent> = {
  [Compatibility.MOGRT]: PremiereProIcon,
  [Compatibility.PremierePro]: PremiereProIcon,
  [Compatibility.AfterEffects]: AfterEffectsIcon,
  [Compatibility.DragAndDrop]: DragAndDropIcon,
  [Compatibility.DaVinciResolve]: DaVinciResolveIcon,
  [Compatibility.FinalCut]: FinalCutProIcon
};
const MGCompatibilityIcon: React.FC<MGCompatibilityIconProps> = ({
  compatibility,
  icon,
  className
}) => {
  const SelectedIcon = compatibilityIcons[compatibility];
  if (SelectedIcon) {
    return <SelectedIcon className={className} />;
  }
  if (icon) {
    return icon;
  }
  console.warn(`No icon found for compatibility "${compatibility}" and no fallback icon provided.`);
  return null;
};
export default MGCompatibilityIcon;